export default __webpack_public_path__ + "static/media/Autodesk-Autocad-01.5b5a284e.svg";